<template>
  <q-card flat>
    <q-card-section>
      <q-banner class="bg-red text-white" rounded inline-actions>
        جهت تعیین صنف کاری به پروفایل مشتری مراجعه نمایید
      </q-banner>
    </q-card-section>
    <q-card-section class="no-padding">
      <q-banner inline-actions class="bg-blue text-white">
        <div>
          <span>پرسشنامه </span> <span>{{ customerInfo.Cs_Name }}</span>
          <q-badge color="red" text-color="white" :label="customerInfo.Cs_Code" align="top"/>
        </div>
        <template v-slot:action>
          <q-btn icon="close" flat round v-close-popup/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section>
      <q-select v-model="selectedQuestionHeader"
                filled
                label="انتخاب پرسشنامه"
                :options="questionsHeader"
                option-value="ID"
                option-label="Title"
                clearable
      >
        <template v-slot:after>
          <q-btn icon="group_work" round flat @click="showCustomerProfile">
            <q-tooltip>
              مشاهده و مدیریت گروه کالاهایی که کار نموده است
            </q-tooltip>
          </q-btn>
        </template>
      </q-select>
    </q-card-section>
    <q-separator spaced/>
    <q-card-section class="no-padding">
      <q-list>
        <q-item v-for="(item,index) in questionsList" :key="index">
          <q-item-section side>
          </q-item-section>
          <q-item-section>
            <q-item-label class="q-mt-sm">
              {{ item.Title }}
              <q-space/>
              <q-input v-model="item.Answer" filled type="textarea"
                       clearable
                       :disable="$store.state.roles.some(v=>['can_see_questionaire'].includes(v))"
                       v-if="JSON.parse(item.AnswerType).ID===1"/>

              <q-input v-model="item.Answer" filled
                       clearable
                       :disable="$store.state.roles.some(v=>['can_see_questionaire'].includes(v))"
                       v-if="JSON.parse(item.AnswerType).ID===2"/>

              <q-input v-model="item.Answer" filled type="number"
                       clearable
                       :disable="$store.state.roles.some(v=>['can_see_questionaire'].includes(v))"
                       v-if="JSON.parse(item.AnswerType).ID===6"/>

              <q-select v-model="item.Answer"
                        filled
                        clearable
                        :disable="$store.state.roles.some(v=>['can_see_questionaire'].includes(v))"
                        :options="JSON.parse(item.Answers)"
                        v-if="JSON.parse(item.AnswerType).ID===4"
              />

              <q-input dir="ltr" filled v-model="item.Answer" mask="date" :rules="['date']"
                       v-if="JSON.parse(item.AnswerType).ID===7"
                       :disable="$store.state.roles.some(v=>['can_see_questionaire'].includes(v))"
                       clearable class="q-mr-xs">
                <template v-slot:append>
                  <q-icon name="event" class="cursor-pointer">
                    <q-popup-proxy ref="qDateProxy" transition-show="scale" transition-hide="scale">
                      <q-date v-model="item.Answer" calendar="persian">
                        <div class="row items-center justify-center">
                          <q-btn v-close-popup label="تایید" color="primary" flat/>
                          <q-btn v-close-popup @click="localStartDate = ToJalaliDate(new Date())" label="امروز"
                                 color="primary"
                                 flat/>
                        </div>
                      </q-date>
                    </q-popup-proxy>
                  </q-icon>
                </template>
              </q-input>
            </q-item-label>
          </q-item-section>
        </q-item>
      </q-list>
    </q-card-section>
    <q-card-actions align="center" v-if="!$store.state.roles.some(v=>['can_see_questionaire'].includes(v))">
      <div class="q-pa-md q-pa-sm justify-start">
        <q-btn label="تایید" icon="search" color="primary" @click="pushData"/>
        <q-btn label="انصراف" v-close-popup
               type="reset" icon="search_off" color="red" flat class="q-ml-sm"/>
      </div>
    </q-card-actions>
    <q-dialog :maximized="$q.screen.lt.md" v-model="customerProfile">
      <GoodsGroupReports :customer="customerInfo" :order-goods-group-list="orderGoodsGroup"
                         :order-goods-list="GoodsList"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import GoodsGroupReports from "@/components/customers/GoodsGroupReports";

export default {
  name: "CustomerQuestions",
  components: {GoodsGroupReports},
  props: {
    customerInfo: {
      type: Object
    }
  },
  data() {
    return {
      customerProfile: false,
      localStartDate: '',
      questionsHeader: [],
      questionsList: [],
      selectedQuestionHeader: undefined,
      GoodsList: [],
      orderGoodsGroup: []
    }
  },
  methods: {
    ...mapActions({
      getQuestionHeaders: 'Questions/crudQuestion',
      getQuestions: 'Questions/crudQuestions',
      crudCustomerQuestion: 'Questions/crudCustomerQuestion',
      GetCustomerSaleInfo: 'Orders/getCustomerSaleInfo',
      GetOrdersGoodsGroup: 'Orders/getOrdersGoodsGroup',
    }),
    showCustomerProfile() {
      this.GetOrdersGoodsGroup(this.customerInfo.Cs_ID).then((res) => {
        this.orderGoodsGroup = JSON.parse(res.data.goods_group);
        this.GoodsList = JSON.parse(res.data.goods);
        this.customerProfile = true
      });
    },
    pushData() {
      this.crudCustomerQuestion({
        CustomerID: this.customerInfo.Cs_ID,
        Questions: this.questionsList
      }).then(() => {
        this.$q.notify({
          type: 'positive',
          position: 'top',
          message: 'اطلاعات ثبت شد'
        })
      })
    }
  },
  watch: {
    selectedQuestionHeader(newValue) {
      if (newValue) {
        this.getQuestions({
          action: 'select',
          ParentID: newValue.ID,
          CustomerID: this.customerInfo.Cs_ID
        }).then((res) => {
          this.questionsList = res
        })
      }
    }
  },
  computed: {},
  created() {
    this.getQuestionHeaders({action: 'select'}).then((res) => {
      this.questionsHeader = res;
    })
  }
}
</script>

<style scoped>

</style>